export default __webpack_public_path__ + "static/media/timor_icon.81d52313.svg";